import Vue from 'vue'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
})
